// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2618":"a3a49631","3119":"8bd1bb06","7311":"7d7e30cd","7497":"590227af","9758":"a3a49631","9911":"0e7b79c0"}[chunkId] + ".chunk.css";
};